import { CheckState } from "@mrdm-self-service-frontend/shared/types";

export function getCheckState(assignedLength: number, allSelectedLength: number): CheckState {
    if (assignedLength === 0) {
        return CheckState.Empty;
    }
    if (assignedLength === allSelectedLength) {
        return CheckState.Selected;
    }
    return CheckState.Partial;
}

export function checkStateHasAccess(node: { checkState: CheckState }): boolean {
    return node.checkState === CheckState.Selected || node.checkState === CheckState.Partial;
}

export function idsArrayEquals(assignedIds: number[], assIds: number[]): boolean {
    if (assignedIds.length === assIds.length) {
        return true;
    }

    const roleAdded = assignedIds.some(id => !assIds.includes(id));
    if (roleAdded) {
        return false;
    }

    const roleRemoved = assIds.some(id => !assignedIds.includes(id));
    return !roleRemoved;
}
